module.exports = __webpack_public_path__ + "img/img-4.b0c4b80d.svg";